import { ApiRoute, HttpMethod, RelativeUrl } from '../common';
import { Location, LocationId } from '../location';
import { GetSimpleAutomatedEmailTemplatesResponse } from '../integration';
import { FitwareTemplate } from '../external';
import { ClientId } from '../client/ClientId';
import { FitwareAutomatedEmailTemplate } from './FitwareAutomatedEmailTemplate';

// This is a list of hardcoded Client IDs to disable Member Engager automated emails for. https://digitalstack.atlassian.net/browse/DPS-471
export const CLIENTS_TO_DISABLE_AUTOMATED_EMAILS: ClientId[] = [ClientId.from(23), ClientId.from(26)];

export function linkToMemberEngager(automatedEmailCode?: string): RelativeUrl {
    let url = '/memberEngager';
    if (automatedEmailCode) {
        url += `?automatedEmailCode=${encodeURIComponent(automatedEmailCode)}`;
    }
    return RelativeUrl.from(url);
}

export function linkToAutomatedEmail(automatedEmailId: number): RelativeUrl {
    return RelativeUrl.from(`/memberEngager/automatedEmail/${String(automatedEmailId)}`);
}

export function getFromNameForFitwareEmail(location: Pick<Location, 'fitwareClubBrand' | 'fitwareClubName'>): string {
    return `${location.fitwareClubBrand} - ${location.fitwareClubName}`;
}

export function getSenderForFitwareEmail(
    location: Pick<Location, 'fitwareClubBrand' | 'fitwareClubEmail' | 'fitwareClubName'>,
): string {
    return `${getFromNameForFitwareEmail(location)} <${location.fitwareClubEmail}>`;
}

interface HasLocationId {
    locationId: LocationId;
}

export interface HasBuilderTemplateFormatId {
    builderTemplateFormatId: number;
}

export interface GetAutomatedEmailParams extends HasLocationId {
    automatedEmailId: number;
}

export interface GetAutomatedEmailResponse {
    fitwareTemplate: FitwareTemplate;
    digitalStackTemplate?: FitwareAutomatedEmailTemplate;
}

export const MemberEngagerApi = {
    getAutomatedEmail: new ApiRoute<GetAutomatedEmailResponse, GetAutomatedEmailParams, void, void>(
        HttpMethod.Get,
        path =>
            path
                .literal('memberEngager')
                .literal('location')
                .param('locationId')
                .literal('automatedEmails')
                .param('automatedEmailId'),
    ),
    getFitwareAutomatedEmails: new ApiRoute<GetSimpleAutomatedEmailTemplatesResponse[], HasLocationId, void, void>(
        HttpMethod.Get,
        path => path.literal('memberEngager').literal('location').param('locationId').literal('automatedEmails'),
    ),
    getFitwareDirectEmailFormat: new ApiRoute<HasBuilderTemplateFormatId, void, void, void>(HttpMethod.Get, path =>
        path.literal('memberEngager').literal('directEmailFormatId'),
    ),
};
